import React, { useState } from 'react';

import OtpInput from 'react-otp-input';

import {
  Box,
  FormHelperText,
  styled,
  useMediaQuery,
} from '@mui/material';

import { LoadingButton } from '../../Loaders';

import { string, ValidationError } from 'yup';

import Axios from '../../../Assets/Axios/Axios';

import { useToastContext } from '../../../Context/ToastContext';

import { COLORS } from '../../../Constant/COLORS';

import { TypoPoppins } from '../../Typo';
import theme from '../../defaultTheme';

import { FORM_STEP } from './index';

import { VerifyCode } from '../../../Server/Query';

const StyledOtpInput = styled(OtpInput)({
  flexGrow: 1,
  aspectRatio: '1',
  maxWidth: '55px',
  '& input': {
    aspectRatio: '1',
    flexGrow: 1,
    fontSize: '1.5rem',
    boxShadow: `1px 1px 2px 1px ${COLORS.grey1} `,
    borderRadius: '4px',
    border: 'none',
  },
});

function VerifyOtp({ updateFormStep, otpReferenceId }) {
  const { showToastMessage } = useToastContext();

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [otp, setOtp] = useState({ value: '', error: '' });
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);

  async function handleSubmit(event) {
    try {
      event.preventDefault();
      setIsSubmitDisabled(true);

      const validatedOtp = await schema.validate(otp.value);

      const query = VerifyCode({
        code: validatedOtp,
        referenceId: otpReferenceId.current,
      });
      const response = await Axios(query);
      if (response.errors) {
        showToastMessage('Something went wrong,Failed to verify your code');
        return undefined;
      }

      if (response.data.VerifyCode.status === 'failed') {
        setOtp(currentState => ({
          ...currentState,
          error: 'Incorrect verification code',
        }));
        return undefined;
      }

      otpReferenceId.current = null;
      updateFormStep({ payload: FORM_STEP.RESETPASSWORD });
    } catch (error) {
      if (error instanceof ValidationError) {
        setOtp(currentState => ({ ...currentState, error: error.message }));
        return undefined;
      }
      showToastMessage('Something went wrong');
    } finally {
      setIsSubmitDisabled(false);
    }
  }

  return (
    <Box
      px={{ xs: 0.5, sm: 3 }}
      py={6}
      component='form'
      onSubmit={handleSubmit}
    >
      <TypoPoppins
        variant='h6'
        variantMapping={{ h6: 'h1' }}
        textAlign='center'
      >
        Verify Your Email
      </TypoPoppins>

      <TypoPoppins textAlign='center' color='text.secondary' mb={4}>
        Please enter the 5 digit code send to <br /> your email address
      </TypoPoppins>

      <StyledOtpInput
        isInputNum
        numInputs={5}
        value={otp.value}
        containerStyle={{
          justifyContent: 'space-between',
          gap: isMobile ? '6px' : '16px',
        }}
        onChange={value => setOtp(currentState => ({ ...currentState, value }))}
        hasErrored={Boolean(otp.error)}
      />
      <FormHelperText
        error={Boolean(otp.error)}
        sx={{ mt: 1, ml: 1.5, textAlign: 'center' }}
      >
        {otp.error}
      </FormHelperText>

      <LoadingButton
        isLoading={isSubmitDisabled}
        type='submit'
        color='blue'
        sx={{ display: 'flex', mx: 'auto', width: 'fit-content', mt: 4 }}
      >
        Submit
      </LoadingButton>
    </Box>
  );
}

const schema = string()
  .required()
  .length(5, 'Verification code should be 5 digit long')
  .label('Verification code');

export default VerifyOtp;
